document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ fabric-filter.js running");

  // 🎯 Find all fabric radios by looking for label text "Cover Material"
  const allOptionGroups = document.querySelectorAll('.swatch-container');
  let fabricRadios = [];
  let travelCaseRadios = [];
  
  allOptionGroups.forEach(group => {
    const label = group.previousElementSibling;
    if (label && label.textContent.trim() === "Cover Material:") {
      fabricRadios = group.querySelectorAll('input[type="radio"]');
    }
    if (label && (label.textContent.trim() === "Travel Case Material:" || label.textContent.trim() === "Material:")) {
      travelCaseRadios = group.querySelectorAll('input[type="radio"]');
    }
  });

  const colorSwatches = document.querySelectorAll('.swatch-wrapper[data-color]');
  console.log("🎯 Fabric radios found:", fabricRadios);
  console.log("🎯 Travel Case radios found:", travelCaseRadios);
  console.log("🎨 Color swatches found:", colorSwatches);

  // 🎒 Initialize Travel Case Add-on Section
  function initializeTravelCaseAddon() {
    console.log("🎒 Initializing travel case add-on...");
    const travelCaseContainer = document.querySelector('.travel-case-swatches');
    if (!travelCaseContainer) {
      console.log("⚠️ Travel case container not found");
      return;
    }

    console.log("✅ Found travel case container:", travelCaseContainer);

    // Define available travel case materials
    const travelCaseMaterials = [
      { name: 'Canvas', handle: 'canvas', color: '#8B7355' },
      { name: 'Leather', handle: 'leather', color: '#8B4513' },
      { name: 'Nylon', handle: 'nylon', color: '#708090' },
      { name: 'Polyester', handle: 'polyester', color: '#C0C0C0' }
    ];

    // Create swatches for each material
    travelCaseMaterials.forEach((material, index) => {
      const swatchWrapper = document.createElement('div');
      swatchWrapper.className = 'swatch-wrapper';
      swatchWrapper.setAttribute('data-available', 'true');
      swatchWrapper.title = material.name;

      const radioInput = document.createElement('input');
      radioInput.type = 'radio';
      radioInput.name = 'travel_case_material';
      radioInput.value = material.handle;
      radioInput.id = `travel-case-${material.handle}`;
      radioInput.setAttribute('data-travel-case-selector', '');

      const swatchLabel = document.createElement('label');
      swatchLabel.className = 'swatch-label swatch-label-square';
      swatchLabel.setAttribute('for', `travel-case-${material.handle}`);
      
      // Try to load image, fallback to color
      const imageUrl = `${material.handle}-swatch.png`;
      swatchLabel.style.backgroundImage = `url(${imageUrl})`;
      swatchLabel.style.backgroundColor = material.color; // Fallback color
      swatchLabel.style.border = '1px solid #ccc';

      const swatchText = document.createElement('span');
      swatchText.className = 'swatch-text';
      swatchText.textContent = material.name;

      swatchWrapper.appendChild(radioInput);
      swatchWrapper.appendChild(swatchLabel);
      swatchWrapper.appendChild(swatchText);
      travelCaseContainer.appendChild(swatchWrapper);
      
      console.log(`✅ Created swatch for ${material.name}`);
    });

    // Add event listeners to travel case radios
    const newTravelCaseRadios = travelCaseContainer.querySelectorAll('input[type="radio"]');
    console.log(`✅ Found ${newTravelCaseRadios.length} travel case radio buttons`);
    
    newTravelCaseRadios.forEach(radio => {
      radio.addEventListener("change", function () {
        console.log("🎒 Travel Case Material changed to:", radio.value);
        updateTravelCaseSelection(radio.value);
      });
    });
  }

  // 🔄 Update travel case selection
  function updateTravelCaseSelection(selectedMaterial) {
    console.log("🎒 Selected travel case material:", selectedMaterial);
    // Here you can add logic to update pricing, cart, etc.
    // For now, we'll just log the selection
  }

  // 🔄 Hide or show colors based on selected fabric
  function updateColorVisibility(selectedFabric) {
    console.log("🔄 Filtering colors for:", selectedFabric);
    colorSwatches.forEach(swatch => {
      const fabrics = (swatch.getAttribute('data-fabrics') || "").split(",");
      const radioInput = swatch.querySelector('input[type="radio"]');

      if (fabrics.includes(selectedFabric)) {
        swatch.style.display = "flex";
        swatch.style.visibility = "visible";
        swatch.style.opacity = "1";
      } else {
        swatch.style.display = "none";
        swatch.style.visibility = "hidden";
        swatch.style.opacity = "0";
        if (radioInput && radioInput.checked) {
          radioInput.checked = false;
        }
      }
    });
  }

  // 🔄 Hide or show travel case materials based on selected color and fabric
  function updateTravelCaseVisibility(selectedColor, selectedFabric) {
    console.log("🔄 Filtering travel case materials for:", selectedColor, selectedFabric);
    
    // Find travel case swatches
    const travelCaseSwatches = document.querySelectorAll('.swatch-wrapper');
    travelCaseSwatches.forEach(swatch => {
      const label = swatch.closest('.swatch-container').previousElementSibling;
      if (label && label.textContent.trim() === "Travel Case Material:") {
        const radioInput = swatch.querySelector('input[type="radio"]');
        if (radioInput) {
          // Check if this travel case material is available for the selected color/fabric combination
          const hiddenDropdown = document.getElementById('hidden-variant-dropdown');
          const variantOptions = hiddenDropdown.querySelectorAll('option');
          let isAvailable = false;
          
          variantOptions.forEach(option => {
            const optionData = option.dataset;
            if (optionData.color === selectedColor && 
                (selectedFabric === '' || optionData.fabric === selectedFabric) &&
                optionData.travelCase === radioInput.value) {
              isAvailable = true;
            }
          });
          
          if (isAvailable) {
            swatch.style.display = "flex";
            swatch.style.visibility = "visible";
            swatch.style.opacity = "1";
          } else {
            swatch.style.display = "none";
            swatch.style.visibility = "hidden";
            swatch.style.opacity = "0";
            if (radioInput.checked) {
              radioInput.checked = false;
            }
          }
        }
      }
    });
  }

  // Function to update the hidden variant dropdown based on selected options
  function updateHiddenVariantDropdown() {
    const hiddenDropdown = document.getElementById('hidden-variant-dropdown');
    if (!hiddenDropdown) {
      console.warn('⚠️ Hidden variant dropdown not found');
      return;
    }

    const selectedOptions = window.getSelectedProductOptions();
    const selections = window.getColorAndFabricSelections();

    console.log('🎯 Selected options:', selectedOptions);

    const colorValue = selections.color;
    const fabricValue = selections.fabric;

    // Find the matching variant
    const variantOptions = hiddenDropdown.querySelectorAll('option');
    let matchingVariant = null;

    variantOptions.forEach(option => {
      const optionData = option.dataset;
      const variantColor = optionData.color;
      const variantFabric = optionData.fabric;
      const variantTravelCase = optionData.travelCase;

      // Check if this variant matches our selected options
      if (colorValue && variantColor === colorValue &&
          (!fabricValue || variantFabric === fabricValue) &&
          (selectedOptions.length <= 2 || variantTravelCase === selectedOptions[2])) {
        matchingVariant = option;
      }
    });

    if (matchingVariant) {
      console.log('✅ Updating hidden dropdown to variant:', matchingVariant.value);
      hiddenDropdown.value = matchingVariant.value;
      
      // Also update the main product select if it exists
      const mainProductSelect = document.querySelector('.product-select');
      if (mainProductSelect) {
        mainProductSelect.value = matchingVariant.value;
      }
      
      // Trigger cart preview update
      document.dispatchEvent(new CustomEvent('variantChanged', { detail: { type: 'dropdown', value: matchingVariant.value } }));
    } else {
      console.warn('⚠️ No matching variant found for selected options:', selectedOptions);
    }
  }

  // ✅ Initialize travel case add-on
  // initializeTravelCaseAddon(); // Removed - travel case materials now come from product variants

  // 🛍️ Initialize Travel Case Navigation in "Shop Now" dropdown
  function initializeTravelCaseNavigation() {
    console.log("🛍️ Initializing travel case navigation...");
    
    // Skip on mobile devices
    if (window.innerWidth <= 768) {
      console.log("🛍️ Skipping travel case navigation on mobile");
      return;
    }
    
    // Skip on non-product pages
    if (!document.querySelector('.product-gallery')) {
      console.log("🛍️ Skipping travel case navigation on non-product page");
      return;
    }
    
    // Find the "Shop Now" menu item
    const shopNowLinks = Array.from(document.querySelectorAll('a')).filter(link => 
      link.textContent.trim().toLowerCase() === 'shop now'
    );
    
    if (shopNowLinks.length === 0) {
      console.log("⚠️ Shop Now link not found");
      return;
    }
    
    shopNowLinks.forEach(shopNowLink => {
      const menuItem = shopNowLink.closest('li');
      if (!menuItem) return;
      
      // Check if this menu item has a dropdown
      const dropdown = menuItem.querySelector('ul');
      if (!dropdown) return;
      
      // Check if travel case navigation already exists
      if (dropdown.querySelector('.travel-case-nav-dropdown')) {
        console.log("✅ Travel case navigation already exists");
        return;
      }
      
      // Create travel case navigation item
      const travelCaseNavItem = document.createElement('li');
      travelCaseNavItem.className = 'header-navigation-list-item secondary-list-item';
      
      const travelCaseNavContent = `
        <div class="travel-case-nav-dropdown">
          <div class="travel-case-nav-header">
            <h4>Travel Case Materials</h4>
          </div>
          
          <div class="travel-case-nav-options">
            <div class="travel-case-nav-item">
              <a href="/collections/travel-cases?filter.v.option.material=Canvas" class="travel-case-nav-link">
                <span class="travel-case-nav-swatch" style="background-color: #8B7355; border: 1px solid #ccc;"></span>
                <span class="travel-case-nav-text">Canvas</span>
              </a>
            </div>
            
            <div class="travel-case-nav-item">
              <a href="/collections/travel-cases?filter.v.option.material=Leather" class="travel-case-nav-link">
                <span class="travel-case-nav-swatch" style="background-color: #8B4513; border: 1px solid #ccc;"></span>
                <span class="travel-case-nav-text">Leather</span>
              </a>
            </div>
            
            <div class="travel-case-nav-item">
              <a href="/collections/travel-cases?filter.v.option.material=Nylon" class="travel-case-nav-link">
                <span class="travel-case-nav-swatch" style="background-color: #708090; border: 1px solid #ccc;"></span>
                <span class="travel-case-nav-text">Nylon</span>
              </a>
            </div>
            
            <div class="travel-case-nav-item">
              <a href="/collections/travel-cases?filter.v.option.material=Polyester" class="travel-case-nav-link">
                <span class="travel-case-nav-swatch" style="background-color: #C0C0C0; border: 1px solid #ccc;"></span>
                <span class="travel-case-nav-text">Polyester</span>
              </a>
            </div>
          </div>
        </div>
      `;
      
      travelCaseNavItem.innerHTML = travelCaseNavContent;
      dropdown.appendChild(travelCaseNavItem);
      
      console.log("✅ Added travel case navigation to Shop Now dropdown");
    });
  }

  // ✅ Initialize travel case navigation (only on desktop and product pages)
  if (window.innerWidth > 768 && document.querySelector('.product-gallery')) {
    initializeTravelCaseNavigation();
  }
  
  // Handle window resize to show/hide travel case navigation
  window.addEventListener('resize', function() {
    const travelCaseNav = document.querySelector('.travel-case-nav-dropdown');
    if (window.innerWidth <= 768) {
      // Remove travel case navigation on mobile
      if (travelCaseNav) {
        travelCaseNav.closest('li').remove();
        console.log("🛍️ Removed travel case navigation on mobile resize");
      }
    } else if (window.innerWidth > 768 && document.querySelector('.product-gallery') && !travelCaseNav) {
      // Add travel case navigation on desktop
      initializeTravelCaseNavigation();
    }
  });

  // ✅ Run once on page load
  const initialSelections = window.getColorAndFabricSelections();

  if (initialSelections.fabric) {
    updateColorVisibility(initialSelections.fabric);
    if (initialSelections.color) {
      updateTravelCaseVisibility(initialSelections.color, initialSelections.fabric);
    }
    updateHiddenVariantDropdown();
  }
  
  // Force initial layout recalculation to fix any spacing issues
  setTimeout(() => {
    const swatchContainers = document.querySelectorAll('.swatch-container');
    swatchContainers.forEach(container => {
      container.style.display = 'none';
      container.offsetHeight; // Force reflow
      container.style.display = 'flex';
    });
  }, 100);

  // 🎛 Re-run every time fabric changes
  fabricRadios.forEach(radio => {
    radio.addEventListener("change", function () {
      console.log("🎛 Fabric changed to:", radio.value);
      updateColorVisibility(radio.value);
      
      // ✅ NEW: Auto-select first available color for this fabric and update image
      autoSelectFirstAvailableColor(radio.value);
      
      // Update travel case visibility based on current color and new fabric
      const currentSelections = window.getColorAndFabricSelections();
      if (currentSelections.color) {
        updateTravelCaseVisibility(currentSelections.color, radio.value);
      }
      
      updateHiddenVariantDropdown();
      
      // Update bundle pricing immediately when fabric changes
      if (typeof updateBundlePricing === 'function') {
        updateBundlePricing(); // Immediate update - no delay needed
      }
      
      // Trigger cart preview update
      document.dispatchEvent(new CustomEvent('variantChanged', { detail: { type: 'fabric', value: radio.value } }));
      
      // Update bundle pricing display immediately when fabric (textile) changes
      if (typeof window.updateBundlePricingDisplay === 'function') {
        setTimeout(() => window.updateBundlePricingDisplay(), 50);
      }
      
                // CRITICAL: Update textile pricing immediately when fabric changes
          if (typeof window.updateTextilePrice === 'function') {
            console.log("🎨 Fabric changed - calling updateTextilePrice()...");
            setTimeout(() => window.updateTextilePrice(), 100);
          } else {
            console.warn("🎨 updateTextilePrice function not found!");
          }
          
          // CRITICAL: Validate inventory immediately when fabric changes
          if (typeof window.validateVariant === 'function') {
            console.log("🔒 Fabric changed - calling validateVariant()...");
            setTimeout(() => window.validateVariant(), 100);
          } else {
            console.warn("🔒 validateVariant function not found!");
          }
          
          // Also try to call the validation directly if the function exists
          if (typeof window.InventoryValidator !== 'undefined' && window.InventoryValidator.validateCurrentVariant) {
            console.log("🔒 Fabric changed - calling InventoryValidator.validateCurrentVariant()...");
            setTimeout(() => window.InventoryValidator.validateCurrentVariant(), 150);
          }
      
      // Force layout recalculation to fix spacing
      setTimeout(() => {
        const swatchContainers = document.querySelectorAll('.swatch-container');
        swatchContainers.forEach(container => {
          container.style.display = 'none';
          container.offsetHeight; // Force reflow
          container.style.display = 'flex';
        });
      }, 50);
    });
  });

  // 🎛 Re-run every time color changes
  colorSwatches.forEach(swatch => {
    const radio = swatch.querySelector('input[type="radio"]');
    if (radio) {
      radio.addEventListener("change", function () {
        console.log("🎨 Color changed to:", radio.value);
        
        // Update travel case visibility based on new color and current fabric
        const currentSelections = window.getColorAndFabricSelections();
        if (currentSelections.fabric) {
          updateTravelCaseVisibility(radio.value, currentSelections.fabric);
        }
        
        updateHiddenVariantDropdown();
        
        // Update main product image if this swatch has a media ID
        if (swatch.dataset.mediaId) {
          updateMainProductImage(swatch.dataset.mediaId);
        }
        
        // Update bundle pricing immediately when color changes
        if (typeof updateBundlePricing === 'function') {
          updateBundlePricing(); // Immediate update - no delay needed
        }
        
        // Trigger cart preview update
        document.dispatchEvent(new CustomEvent('variantChanged', { detail: { type: 'color', value: radio.value } }));
        
        // Update bundle pricing display immediately when color changes
        if (typeof window.updateBundlePricingDisplay === 'function') {
          setTimeout(() => window.updateBundlePricingDisplay(), 50);
        }
        
        // CRITICAL: Update textile pricing immediately when color changes
        if (typeof window.updateTextilePrice === 'function') {
          console.log("🎨 Color changed - calling updateTextilePrice()...");
          setTimeout(() => window.updateTextilePrice(), 100);
        } else {
          console.warn("🎨 updateTextilePrice function not found!");
        }
        
        // CRITICAL: Validate inventory immediately when color changes
        if (typeof window.validateVariant === 'function') {
          console.log("🔒 Color changed - calling validateVariant()...");
          setTimeout(() => window.validateVariant(), 100);
        } else {
          console.warn("🔒 validateVariant function not found!");
        }
        
        // Also try to call the validation directly if the function exists
        if (typeof window.InventoryValidator !== 'undefined' && window.InventoryValidator.validateCurrentVariant) {
          console.log("🔒 Color changed - calling InventoryValidator.validateCurrentVariant()...");
          setTimeout(() => window.InventoryValidator.validateCurrentVariant(), 150);
        }
        
        // Force layout recalculation to fix spacing
        setTimeout(() => {
          const swatchContainers = document.querySelectorAll('.swatch-container');
          swatchContainers.forEach(container => {
            container.style.display = 'none';
            container.offsetHeight; // Force reflow
            container.style.display = 'flex';
          });
        }, 50);
      });
    }
  });

  // 🎛 Re-run every time travel case material changes
  travelCaseRadios.forEach(radio => {
    radio.addEventListener("change", function () {
      console.log("🎒 Travel Case Material changed to:", radio.value);
      updateHiddenVariantDropdown();
      
      // Update main product image if this swatch has a media ID
      const swatchWrapper = radio.closest('.swatch-wrapper');
      if (swatchWrapper && swatchWrapper.dataset.mediaId) {
        updateMainProductImage(swatchWrapper.dataset.mediaId);
      }
      
      // Update bundle pricing when travel case material changes
      if (typeof updateBundlePricing === 'function') {
        updateBundlePricing();
      }
      
      // Trigger cart preview update
      document.dispatchEvent(new CustomEvent('variantChanged', { detail: { type: 'travelCase', value: radio.value } }));
    });
  });

  // 🎛 Add event listeners for travel case swatches specifically
  const travelCaseSwatches = document.querySelectorAll('.swatch-wrapper[data-material]');
  travelCaseSwatches.forEach(swatch => {
    const radio = swatch.querySelector('input[type="radio"]');
    if (radio) {
      radio.addEventListener("change", function () {
        console.log("🎒 Travel Case swatch clicked:", swatch.dataset.material);
        if (swatch.dataset.mediaId) {
          updateMainProductImage(swatch.dataset.mediaId);
        }
        
        // Update bundle pricing when travel case swatch changes
        if (typeof updateBundlePricing === 'function') {
          updateBundlePricing();
        }
      });
    }
  });

  // 🎛 Also listen for any material option changes (for travel case products)
  const materialRadios = document.querySelectorAll('input[type="radio"][name*="option"]');
  materialRadios.forEach(radio => {
    radio.addEventListener("change", function () {
      console.log("🎒 Material option changed to:", radio.value);
      updateHiddenVariantDropdown();
      
      // Update main product image if this is a travel case swatch
      const swatchWrapper = radio.closest('.swatch-wrapper');
      if (swatchWrapper && swatchWrapper.dataset.mediaId) {
        updateMainProductImage(swatchWrapper.dataset.mediaId);
      }
      
              // Update bundle pricing immediately when material options change
        if (typeof updateBundlePricing === 'function') {
          updateBundlePricing(); // Immediate update - no delay needed
        }
        
        // Trigger cart preview update
        document.dispatchEvent(new CustomEvent('variantChanged', { detail: { type: 'material', value: radio.value } }));
    });
  });

  // 🎨 Function to auto-select first available color for a fabric
  function autoSelectFirstAvailableColor(selectedFabric) {
    console.log("🎨 Auto-selecting first available color for fabric:", selectedFabric);
    
    // Find all visible color swatches for this fabric
    const availableColorSwatches = Array.from(colorSwatches).filter(swatch => {
      const fabrics = (swatch.getAttribute('data-fabrics') || "").split(",");
      return fabrics.includes(selectedFabric) && swatch.style.display !== 'none';
    });
    
    if (availableColorSwatches.length > 0) {
      const firstAvailableColor = availableColorSwatches[0];
      const colorRadio = firstAvailableColor.querySelector('input[type="radio"]');
      
      if (colorRadio && !colorRadio.checked) {
        console.log("🎨 Auto-selecting color:", colorRadio.value);
        
        // Uncheck all other color radios
        colorSwatches.forEach(swatch => {
          const radio = swatch.querySelector('input[type="radio"]');
          if (radio) radio.checked = false;
        });
        
        // Check the first available color
        colorRadio.checked = true;
        
        // Update the main product image if this swatch has a media ID
        if (firstAvailableColor.dataset.mediaId) {
          updateMainProductImage(firstAvailableColor.dataset.mediaId);
        }
        
        // Trigger change event to update other systems
        const changeEvent = new Event('change', { bubbles: true });
        colorRadio.dispatchEvent(changeEvent);
        
        console.log("✅ Auto-selected color and updated image");
      }
    } else {
      console.warn("⚠️ No available colors found for fabric:", selectedFabric);
    }
  }

  // 🖼️ Function to update main product image
  function updateMainProductImage(mediaId) {
    console.log("🖼️ Updating main product image to media ID:", mediaId);
    
    // Find the main product image - corrected selector
    const mainImage = document.querySelector('.product-gallery--viewport--figure[data-product-gallery-selected="true"] .product-gallery--media-wrapper img');
    if (!mainImage) {
      console.warn("⚠️ Main product image not found");
      return;
    }
    
    // Find the variant image with this media ID
    const variantImage = document.querySelector(`[data-media-id="${mediaId}"] img`);
    if (variantImage) {
      // Update the main image source
      mainImage.src = variantImage.src;
      mainImage.srcset = variantImage.srcset;
      console.log("✅ Updated main product image");
    } else {
      console.warn("⚠️ Variant image not found for media ID:", mediaId);
    }
  }
  
  // 🎛 Listen for main product select dropdown changes
  const mainProductSelect = document.querySelector('.product-select');
  if (mainProductSelect) {
    mainProductSelect.addEventListener('change', function() {
      console.log("🎛 Main product select changed to:", this.value);
      // Trigger cart preview update
      document.dispatchEvent(new CustomEvent('variantChanged', { detail: { type: 'select', value: this.value } }));
    });
  }
});
